// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"deeppurple-amber":"b5d4ffbac663d6f31a76","indigo-pink":"e0ec0d09b786f5081e4c","pink-bluegrey":"be94c46ac1a07aa9185d","purple-green":"f9743ac58aa8f5af3854","styles":"b63d0aa8ccdb58f3da54"}[chunkId] + ".css";
};